import { AfterViewInit, Component, Input, OnInit, Type, ViewChild } from '@angular/core';
import { AbstractControl, UntypedFormBuilder, FormControl, UntypedFormGroup, ValidatorFn } from '@angular/forms';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { ELookup } from 'src/app/modules/compliance/constants/eLookup';
import { Messages } from 'src/app/modules/compliance/constants/messages';
import { emptySportSeasonValidation, emptyStudent, emptyTrasferHistory } from 'src/app/modules/compliance/constants/prepareEmptyObject';
import { ApiResult } from 'src/app/shared/model/apiresult';
import { LookupService } from 'src/app/modules/maintenance/services/lookup.service';
import * as _moment from 'moment';
import { default as _rollupMoment } from 'moment';
import { ILookup } from 'src/app/shared/model/Index';
import { ITransferHistory } from '../../model/transferhistory';
import { TransferHistoryService } from '../../services/transfer-history.service';
import { Guid } from 'guid-typescript';
import { environment as env } from '@environments/environment'
import { ConfirmationDialog } from '../../component/confirmation-dialog.component';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { MatSort } from '@angular/material/sort';
import { ISportSeasonResult } from '@app/modules/search/model/studentSearchResult';
import { MatLegacyPaginator as MatPaginator } from '@angular/material/legacy-paginator';
import { ActivatedRoute } from '@angular/router';
import { debounceTime, distinctUntilChanged, map, startWith, switchMap } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { ISportSeasonValidation } from '../../model/sportseasonvalidation';
import { ESportParticipationTypeCode } from '../../constants/eSportParticipationType';
import { StudentHighSchoolService } from '@app/modules/prospective/services/student-highschool.service';
import { InstitutionSearchDialog } from '@app/modules/shared/component/institution-search/institution-search.component';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';


@Component({
    selector: 'transfer-history',
    templateUrl: './transfer-history.component.html'
})
export class TransferHistoryComponent implements OnInit, AfterViewInit  {
    institutionSearchDialogRef: any;
    public transferHistory: ITransferHistory = emptyTrasferHistory();
    public sportSeasonValidation: ISportSeasonValidation = emptySportSeasonValidation();
    public states: ILookup[];
    public sportSeasonList: ILookup[];
    public sportTypeList: ILookup[];
    public institutionList: ILookup[];
    public sportParticipationList: ILookup[];
    public ftrs: ILookup[];
    public athleticFinancialAidRenewalTypeList: ILookup[];
    public transferHistoryFormGroup: UntypedFormGroup;
    currentDate = new Date();
    studentID: string = '';
    isShown: boolean = false;
    displayedColumns: string[] = ['sportType', 'sportSeason'];
    dataSource = new MatTableDataSource<ISportSeasonResult>();
    @ViewChild(MatSort, { static: true }) sort: MatSort;
    @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
    @Input() WriteCompliance:boolean=false;

    constructor(
        private _snackBar: MatSnackBar,
        private _formBuilder: UntypedFormBuilder,
        private _lookupservice: LookupService,
        private _transferhistoryservice: TransferHistoryService,
        private _route: ActivatedRoute,
        private dialog: MatDialog) {
        //Form Group Initiation.
        this.fillForm(this.transferHistory);
    }
    ngOnInit() {
        this._route.queryParams.subscribe(params => {
            this.studentID = params.id;
        });
        this.getActiveLookups(ELookup.SportType);
        this.getActiveLookups(ELookup.SportSeason);
        this.getActiveLookups(ELookup.SportParticipationType);
        this.getActiveLookups(ELookup.AthleticFinancialAidRenewalType);
        this.getActiveLookups(ELookup.FTR);
        this.getTransferHistory();
        //this.instituteTypeahead();
    }
    
    ngAfterViewInit(): void {
        this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);
    }
    cancel() {
        this.transferHistory = emptyTrasferHistory();
        this.fillForm(this.transferHistory);
        //this.autoInstitutionId.setValue(null);
        this.isShown = false;
    }
    add() {
        this.transferHistory = emptyTrasferHistory();
        this.fillForm(this.transferHistory);
        this.isShown = true;
        this.institutionList = [];
    }
    edit(id: Guid) {
        this.isShown = true;
        this.institutionList = [];
        this.getTransferHistoryById(id);
    }
    delete(id: Guid) {
        this.deleteTransferHistoryById(id);
        this.cancel();
    }
    openDialog() {
        this.institutionSearchDialogRef = this.dialog.open(InstitutionSearchDialog, { width: '70%', height: '70%', data: { searchText: this.transferHistoryFormGroup.controls["institutionDescription"].value.replace(/\s*\(.*?\)\s*/g, ''), studentID: this.studentID,isHighSchool:false,title:'University Search' } });
        this.institutionSearchDialogRef.afterClosed().subscribe((result: any) => {
            if (result) {
                var formattedDescription = result['description'] + " (" + result["code"] + ")";
                this.transferHistoryFormGroup.get('institutionDescription').setValue(formattedDescription);
                this.transferHistoryFormGroup.get('institutionId').setValue(result["id"]);
                this.transferHistoryFormGroup.get('isJuniorCollege').setValue(result["isJuniorCollege"]);
                this.transferHistory.institutionId = result['id'];
                this.transferHistory.institutionDescription = formattedDescription;
            }
        });
    }

    private getTransferHistory() {
        this._transferhistoryservice.get(Guid.parse(this.studentID).toJSON().value).subscribe((result: ApiResult<ISportSeasonResult[]>) => {
            if (result.validationErrors == null && result.value != null) {
                this.dataSource = new MatTableDataSource<ISportSeasonResult>(result.value);
                this.dataSource.paginator = this.paginator;
                this.dataSource.sort = this.sort;
            }
        }, error => console.error(error));
    }

    private getActiveLookups(tableName: string) {
        this._lookupservice.getActiveLookups(tableName).subscribe((result: ApiResult<ILookup[]>) => {
            if (result.validationErrors == null) {
                switch (tableName) {
                    case ELookup.SportType:
                        this.sportTypeList = result.value;
                        break;
                    case ELookup.SportSeason:
                        this.sportSeasonList = result.value;
                        break;
                    case ELookup.States:
                        this.states = result.value;
                        break;
                    case ELookup.SportParticipationType:
                        this.sportParticipationList = result.value.filter(option =>
                            option.code !== ESportParticipationTypeCode.Manager && option.code !== ESportParticipationTypeCode.RemovedFromTeam);
                        break;
                    case ELookup.AthleticFinancialAidRenewalType:
                        this.athleticFinancialAidRenewalTypeList = result.value;
                        break;
                    case ELookup.FTR:
                        this.ftrs = result.value;
                        break;
                    default:
                        break;
                }
            }
        }, error => console.error(error));
    }

    private getTransferHistoryById(id: Guid) {
        this._transferhistoryservice.getTransferHistoryById(id).subscribe((result: ApiResult<ITransferHistory>) => {
            if (result.validationErrors == null && result.value != null) {
                this.transferHistory = result.value;
                this.fillForm(this.transferHistory)
            }
        }, error => console.error(error));
    }
    private deleteTransferHistoryById(id: Guid) {
        this._transferhistoryservice.delete(id).subscribe((result: ApiResult<any>) => {
            if (result.validationErrors == null) {
                this.getTransferHistory();
            }
        }, error => console.error(error));
    }
    private fillForm(transferHistory: ITransferHistory) {
        this.transferHistoryFormGroup = this._formBuilder.group(
            {
                studentId: [transferHistory.studentId],
                tenantId: [transferHistory.tenantId],
                studentTransferSeasonId: [transferHistory.studentTransferSeasonId],
                institutionId: [transferHistory.institutionId],
                institutionDescription: [transferHistory.institutionDescription],
                sportTypeId: [transferHistory.sportTypeId],
                sportSeasonId: [transferHistory.sportSeasonId],
                participationTypeId: [transferHistory.participationTypeId],
                freshmanQualificationTypeId: [transferHistory.freshmanQualificationTypeId],
                isMedicalHardship: [transferHistory.isMedicalHardship],
                athleticFinancialAidRenewalTypeId: [transferHistory.athleticFinancialAidRenewalTypeId],
                isJuniorCollege: [{ value: transferHistory.isJuniorCollege, disabled: true }],
                isJuniorCollegeGraduate: [transferHistory.isJuniorCollegeGraduate],
            });
    }
    public onSubmit() {
        this.transferHistory = this.transferHistoryFormGroup.getRawValue() as ITransferHistory;

        // add warning for duplicate season if applicable
        var sportTypeDescription = this.sportTypeList.filter(x => x.id === this.transferHistory.sportTypeId)[0].description;
        var sportSeasonDescription = this.sportSeasonList.filter(x => x.id === this.transferHistory.sportSeasonId)[0].description;
        if(this.dataSource.data.filter(x => x.sportType === sportTypeDescription && x.sportSeason === sportSeasonDescription).length > 0)
        {
            const dialogRef = this.dialog.open(ConfirmationDialog, {
                data: { message: Messages.DuplicateTransferSeasonConfirm }
            });
            dialogRef.afterClosed().subscribe((confirmed: boolean) => {
                if (confirmed) {
                    this.addOrUpdate();
                }
            });
        }
        else
        {
            this.addOrUpdate();
        }
    }

    addOrUpdate()
    {
        if (this.transferHistory.studentTransferSeasonId !== null) {
            this._transferhistoryservice.put(this.transferHistory).subscribe((result: ApiResult<any>) => {
                if (result.statusCode == 200) {
                    this.notify(Messages.TransferHistorySaved);
                    this.getTransferHistory();
                }
                else {
                    this.notifyWarnings(result.validationErrors);
                }
            }, error => { this.transferHistory.studentTransferSeasonId = null; console.error(error) });
        }
        else {
            this.transferHistory.studentId = Guid.parse(this.studentID).toJSON().value;
            this.transferHistory.tenantId = Guid.parse(env.tenantId).toJSON().value;
            this.transferHistory.studentTransferSeasonId = Guid.createEmpty().toJSON().value;
            this._transferhistoryservice.post(this.transferHistory).subscribe((result: ApiResult<any>) => {
                if (result.statusCode == 200) {
                    this.cancel();
                    this.notify(Messages.TransferHistorySaved);
                    this.getTransferHistory();
                }
                else {
                    this.transferHistory.studentTransferSeasonId = null;
                    this.notifyWarnings(result.validationErrors);
                }
            }, error => { this.transferHistory.studentTransferSeasonId = null; console.error(error) });
        }
    }

    notifyWarnings(message: string[]) {
        let snackBarRef = this._snackBar.open(message[0], "Close", {
            duration: 5000,
            panelClass: ['red-snackbar']
        });
        snackBarRef.afterDismissed().subscribe(() => {
        });
    }
    notify(message: string, panelCSS?: string) {
        let snackBarRef = this._snackBar.open(message, "Close", {
            duration: 2000,
            panelClass: [panelCSS]
        });
        snackBarRef.afterDismissed().subscribe(() => {
        });
    }

    evalBind(data:ILookup,currentValue:number){
        if(data.id==currentValue){
            return true;
        }
      return !data.disabled;
    }
}
